"use strict";

var _slicedToArray = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.parse = void 0;

var _prop = _interopRequireDefault(require("./prop"));

var _type = _interopRequireDefault(require("./type"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var parseBibTeXJSON = function parseBibTeXJSON(data) {
  return [].concat(data).map(function (entry) {
    var newEntry = {};
    var toMerge = [];

    for (var prop in entry.properties) {
      var oldValue = entry.properties[prop];

      var _ref = (0, _prop.default)(prop, oldValue) || [],
          _ref2 = _slicedToArray(_ref, 2),
          cslField = _ref2[0],
          cslValue = _ref2[1];

      if (cslField) {
        if (/^[^:\s]+?:[^.\s]+(\.[^.\s]+)*$/.test(cslField)) {
          toMerge.push([cslField, cslValue]);
        } else {
          newEntry[cslField] = cslValue;
        }
      }
    }

    newEntry.type = (0, _type.default)(entry.type);
    newEntry.id = newEntry['citation-label'] = entry.label;

    if (/\d(\D+)$/.test(entry.label)) {
      newEntry['year-suffix'] = entry.label.match(/\d(\D+)$/)[1];
    }

    toMerge.forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          cslField = _ref4[0],
          value = _ref4[1];

      var props = cslField.split(/:|\./g);
      var cursor = newEntry;

      while (props.length > 0) {
        var _prop2 = props.shift();

        cursor = cursor[_prop2] || (cursor[_prop2] = !props.length ? value : isNaN(+props[0]) ? {} : []);
      }
    });
    return newEntry;
  });
};

exports.default = exports.parse = parseBibTeXJSON;